export enum AsyncStorageKeyEnum {
    StoreList = "StoreList",
    CurrentUser="CurrentUser",
    PERSISTENCE_KEY = "PERSISTENCE_KEY"
}